import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isPlatformWeb } from 'renative';

import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import { NavConfig } from '@24i/nxg-sdk-gluons/src/clients/AppNavigationClient';
import { getRuntimeConfig } from '@24i/nxg-sdk-smartott/src/Application/initApp';
import { useAppConfigQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/useAppConfigQuery';
import { useMenuQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/menu/useMenuQuery';
import { useUserQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/user/useUserQuery';

import { useAppNavigation } from '../../context/AppNavigation';
import { useProfilesQuery } from './useProfilesQuery';

const emptyParams = {};

export const useNavigationConfigQuery = () => {
    const { appSettings } = useAppConfigQuery();
    const { client } = useAppNavigation();
    const { data: menuConfig } = useMenuQuery();
    const { profiles, selectedProfile } = useProfilesQuery();
    const { t } = useTranslation();
    const { user } = useUserQuery();
    const runtimeConfigMenu = getRuntimeConfig('menu');
    const router = useRouter();

    const routeParams = isPlatformWeb ? router.query : emptyParams;
    const data = useMemo<NavConfig | undefined>(() => {
        if (!menuConfig || !appSettings) {
            return undefined;
        }
        return client.getNavigationConfig(menuConfig, runtimeConfigMenu, {
            t,
            user,
            profiles,
            selectedProfile,
            features: appSettings.features,
            params: routeParams,
        });
    }, [user?.id, profiles, selectedProfile, menuConfig, routeParams, appSettings]);
    const lastDataRef = useRef(data);
    if (data) lastDataRef.current = data;

    return {
        isLoading: false,
        navigationConfig: data || lastDataRef.current,
    };
};
